import React from "react";
import SearchBar from "../common/SearchBarActivities";
import EmptyActivities from "../common/EmptyActivities";
import ReusableCard from "../common/ReusableCard";
import JobImage from "assets/images/Jobs.png";
import BodyHeader from "../common/BodyHeader";
import ViewIcon from "assets/icons/View.svg";

const SavedJobs = () => {
  const [jobs, setJobs] = React.useState([
    {
      id: 1,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Open",
    },
    {
      id: 2,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Hired",
    },
    {
      id: 3,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Cancelled",
    },
    {
      id: 4,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Completed",
    },
    {
      id: 5,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Hired",
    },
    {
      id: 6,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Open",
    },
    {
      id: 7,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Completed",
    },
    {
      id: 8,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Cancelled",
    },
    {
      id: 9,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Open",
    },
    {
      id: 10,
      title: "Kitchen Faucet Repair",
      jobId: "34291",
      address: "123 Oak Street, Austin, TX",
      date: "12/15/2024",
      tasks: 5,
      status: "Cancelled",
    },
  ]);

  return (
    <div className=" max-w-[1440px] m-auto md:py-12 py-8 md:px-6 px-4 ">
      {" "}
      <div className="pt-[70px]">
        <div className="md:py-12 py-6 flex flex-col md:gap-12 gap-4">
          <BodyHeader
            title="Saved Jobs"
            description="Your bookmarked jobs across all statuses. Use this space to quickly
            revisit jobs you want to monitor, follow up on, or keep for
            reference."
          >
            {" "}
            {/*{!!jobs && (*/}
            {/*  <button className="bg-[#3cab5c] text-nowrap flex gap-2 items-center justify-center h-12   w-fit hover:bg-[#3c8f47] text-white  px-3 sm:text-[14px] lg:text-[16px]   py-3 rounded-xl font-medium">*/}
            {/*    <img*/}
            {/*      src={ViewIcon}*/}
            {/*      className="w-[14px] h-[14px] svg-drop "*/}
            {/*    ></img>{" "}*/}
            {/*    View Job Listing*/}
            {/*  </button>*/}
            {/*)}*/}
          </BodyHeader>

          <SearchBar
            label="Search Job"
            placeholder="Search by Job Title or Property"
            select={[
              { label: "Job Status", values: ["A", "B", "C"] },
              { label: "Category", values: ["A", "B", "C"] },
              { label: "Sort by", values: ["A", "B", "C"] },
            ]}
          ></SearchBar>
        </div>
        {jobs.length ? (
          <div className=" md:py-4 py-2">
            {" "}
            <ReusableCard
              resultsPerPage={10}
              jobs={jobs}
              classGrid="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 "
            ></ReusableCard>
          </div>
        ) : (
          <EmptyActivities
            label="You haven’t saved any jobs yet."
            description="Click the bookmark icon on any job to save it for later review."
            img={JobImage}
            additionalButton={true}
          ></EmptyActivities>
        )}
      </div>
    </div>
  );
};

export default SavedJobs;
